import { IJsonSerializable, IOpChangeState, IReferenceType, ICopyable } from '../util/interfaces'
import { Enums } from '../common/enums'
import { OpDescr } from './op-descr'
import { OpPaymentModuleType } from './op-payment-module-type'

export class OpPaymentModule implements IReferenceType, IOpChangeState, IJsonSerializable {

    // #region Properties

    public idPaymentModule: number
    public name: string
    public idPaymentModuleType: number
    public idDescr: number

    // #endregion


    // #region Navigation Properties

    public paymentModuleType: OpPaymentModuleType
    public descr: OpDescr

    // #endregion


    // #region Ctor

    constructor(opObj: any = null) {
        this.fromJSON(opObj)
    }

    // #endregion


    // #region IOpChangeState implementation

    public opState: Enums.OpChangeState

    // #endregion


    // #region IReferenceType implementation

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdPaymentModule
    }

    public getReferenceKey(): number {
        return this.idPaymentModule
    }

    public getReferenceValue(): any {
        return this
    }

    // #endregion


    // #region IJsonSerializable implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idPaymentModule = opObj.ID_PAYMENT_MODULE
            this.name = opObj.NAME
            this.idPaymentModuleType = opObj.ID_PAYMENT_MODULE_TYPE
            this.idDescr = opObj.ID_DESCR

            this.paymentModuleType = opObj._PaymentModuleType != null ? new OpPaymentModuleType(opObj._PaymentModuleType) : null
            this.descr = opObj._Descr != null ? new OpDescr(opObj._Descr) : null

            this.opState = this.opState
        } else {
            this.idPaymentModule = 0

            this.opState = Enums.OpChangeState.New
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_PAYMENT_MODULE: this.idPaymentModule,
            NAME: this.name,
            ID_PAYMENT_MODULE_TYPE: this.idPaymentModuleType,
            ID_DESCR: this.idDescr,

            _PaymentModuleType: this.paymentModuleType ? this.paymentModuleType.toJSON() : null,
            _Descr: this.descr ? this.descr.toJSON() : null,
            opState: this.opState
        }
    }

    // #endregion


    // #region ICopyable

    public clone(includeNavigationProperties: boolean, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpPaymentModule {
        const paymentModule: OpPaymentModule = new OpPaymentModule()

        paymentModule.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return paymentModule
    }

    public copy(source: OpPaymentModule, includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): void {

        if (source == null) {
            return null
        }

        if (includeNavigationProperties) {
            this.descr = source.descr // TODO Zaimplementować ICopyable

            this.paymentModuleType = source.paymentModuleType != null ? source.paymentModuleType.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues) : null
        }

        if (includeCustomProperties) {
            // No Custom Properties
        }

        if (includeDataList) {
            // No Data List
        }

        if (includeDynamicValues) {
            // No Dynamic Values
        }

        this.idPaymentModule = source.idPaymentModule
        this.name = source.name
        this.idPaymentModuleType = source.idPaymentModuleType
        this.idDescr = source.idDescr

        this.opState = source.opState
    }

    // #endregion 

    public toString(): string {
        return this.name
    }
}
